module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-note-d91dd82a5fd40e8f1297734b8c7e8017.svg";